import { render, staticRenderFns } from "./appliedPotential.vue?vue&type=template&id=63e75f7c&scoped=true"
import script from "./appliedPotential.vue?vue&type=script&lang=js"
export * from "./appliedPotential.vue?vue&type=script&lang=js"
import style0 from "./appliedPotential.vue?vue&type=style&index=0&id=63e75f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e75f7c",
  null
  
)

export default component.exports